var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6b38a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 12,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,80)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,0) rotate(-12 120 180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 60 q40 -40 80 0 v120 q0 16 -14 18 h-52 q-14 -2 -14 -18 z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 66 q36 -32 72 0",
    stroke: "#f3d6c3",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,0) rotate(10 120 180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 60 q40 -40 80 0 v120 q0 16 -14 18 h-52 q-14 -2 -14 -18 z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 66 q36 -32 72 0",
    stroke: "#f3d6c3",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260 60 q20 -24 44 -30",
    stroke: "#ffd9b8",
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 24,
    r: 6,
    fill: "#ffd9b8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 18,
    r: 4,
    fill: "#f6e1d2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheers);
export default __webpack_public_path__ + "static/media/cheers.2633973495364da0a218bb1b5661174a.svg";
export { ForwardRef as ReactComponent };